import React, { useMemo } from 'react';
import { INSURANCE_CONVENTIONS_LIST_QUERY } from '../queries';
import { getListBrowserStore } from '@ts-private/list-browser';
import ListAltIcon from '@mui/icons-material/ListAlt';
import { Card } from '@totalsoft/rocket-ui';
import { ExportModalComponent } from 'components/common/export/ExportModalComponent';
import TableListBrowser from 'features/common/components/table-list-browser/TableListBrowser';
import InsuranceConventionComponent from './InsuranceConventionComponent';
import ApolloFetchingComponent from 'features/common/components/apollo-fetching/ApolloFetchingComponent';

export const insuranceConventionsStore = getListBrowserStore({
  filterDefinitions: [
    {
      name: 'productCode',
      caption: 'InsuranceConventions.Code',
      type: 'text'
    },
    {
      name: 'productName',
      caption: 'InsuranceConventions.Name',
      type: 'text'
    },
    {
      name: 'isActive',
      caption: 'InsuranceConventions.IsActive',
      type: 'boolean'
    }
  ],
  orderByFields: [
    {
      caption: 'InsuranceConventions.Name',
      value: 'ProductName'
    },
    {
      caption: 'InsuranceConventions.Code',
      value: 'ProductCode'
    },
    {
      caption: 'InsuranceConventions.IsActive',
      value: 'IsActive'
    }
  ],
  pager: {
    orderBy: 'ProductName',
    direction: 'asc'
  }
});

const InsuranceConventionsListBrowser = () => {
  const fetchingOptions = useMemo(
    () => ({
      queryOptions: {
        query: INSURANCE_CONVENTIONS_LIST_QUERY,
        name: 'insuranceConventionsList'
      }
    }),
    []
  );

  const columns = useMemo(
    () => [
      { name: 'code', caption: 'InsuranceConventions.Code' },
      { name: 'name', caption: 'InsuranceConventions.Name' },
      { name: 'isActive', caption: 'InsuranceConventions.IsActive', width: 15, align: 'center' },
      { name: 'actions', caption: 'Actions', width: 15 }
    ],
    []
  );

  return (
    <Card icon={ListAltIcon}>
      <TableListBrowser
        name='insurance-conventions-browser'
        store={insuranceConventionsStore}
        ItemComponent={InsuranceConventionComponent}
        columns={columns}
      />
      <ExportModalComponent store={insuranceConventionsStore} options={fetchingOptions} />
      <ApolloFetchingComponent store={insuranceConventionsStore} options={fetchingOptions} />
    </Card>
  );
};

export default InsuranceConventionsListBrowser;
